<div class="item-wrapper">
    <span multilang class="title">Anzahl Bewertungen</span>
    <div class="body">
        <div class="slider-container">
            <div class="slider-track"></div>
            <div class="range" [ngStyle]="{'left': minPercent() + '%', 'width': rangeWidth() + '%'}"></div>

            <input type="range" [min]="min()" [max]="max()" [step]="step()" [value]="minValue_t()" #minValuet
                (input)="updateRange(minValuet.value, max())" (change)="sendValue()" />

            <!-- <input type="range" [min]="min()" [max]="max()" [step]="step()" [value]="maxValue_t()" #maxValuet (input)="updateRange(minValuet.value, maxValuet.value)" (change)="sendValue()"/> -->

        </div>
        <div class="valuewrapper">
            <span multilang>{{minValue_t()}}</span>
            <span multilang>{{maxValue_t() < max() ? maxValue_t() : 'beliebig' }}</span>
        </div>
    </div>
</div>